module.exports = __webpack_public_path__ + "img/KW.10606d62.webp";